import React, { useState, useRef, useEffect, useContext } from 'react';
import tw from 'twin.macro';
import { AppContext } from '../context';
import { Icon } from '../icon';
import { TimesIcon, DumpertLogoIcon } from 'icons';
import { useKonamiCode } from '../common/hooks';
import { soundsList } from './soundsList';
import { TextLine } from '../text';

const Item = ({ sound, index }) => {
  const soundRef = useRef();
  const soundurl = 'https://cdn.dumpert.nl/soundboard/';
  const [itemPlaying, setItemPlaying] = useState(false);

  const playSound = () => {
    const audio = soundRef.current.children[1];

    if (!audio) return;

    setItemPlaying(true);
    audio.currentTime = 0;
    audio.play();
    audio.addEventListener('ended', () => {
      setItemPlaying(false);
    });
  };

  return (
    <div
      ref={soundRef}
      onClick={playSound}
      css={[
        tw`transition duration-200 ease-in-out transform origin-center rounded-md cursor-pointer 
        hover:scale-110 z-10 basis-1/4 md:basis-1/6 xl:basis-1/12`,
        itemPlaying && tw`transform scale-110 z-20 ring-2 ring-brand`,
      ]}
    >
      <img
        alt={sound.title}
        src={`${soundurl + (index + 1)}.png`}
        tw='rounded-lg w-full h-full object-cover'
      />
      <audio data-key={sound.dataKey} src={`${soundurl + (index + 1)}.mp3`}></audio>
    </div>
  );
};

export const SoundBoard = () => {
  const isKonamiCode = useKonamiCode();

  const { soundBoardActive, setSoundBoardActive } = useContext(AppContext);

  useEffect(() => {
    if (isKonamiCode) {
      setSoundBoardActive(true);
    }
  }, [isKonamiCode]);

  useEffect(() => {
    if (soundBoardActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [soundBoardActive]);

  return (
    <>
      {soundBoardActive && (
        <div tw='fixed inset-0 z-[9999] bg-primary bg-opacity-70 backdrop-blur-lg'>
          <div tw='absolute inset-0 overflow-y-auto md:p-10 pt-6'>
            <div tw='flex relative justify-center items-center mb-2'>
              <DumpertLogoIcon tw='fill-brand w-1/3' />
              <Icon
                Type={TimesIcon}
                tw='cursor-pointer hover:text-danger transition-all fixed top-4 right-4'
                data-action='close'
                size='large'
                onClick={() => setSoundBoardActive(false)}
              />
            </div>
            <div tw='w-full flex justify-center mb-2'>
              <TextLine black>Geheime soundboard</TextLine>
            </div>
            <div tw='flex flex-wrap items-center justify-center gap-4'>
              {soundsList.map((sound, index) => (
                <Item key={sound.title} {...{ sound, index }} />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
